import axios from "axios";

export const apiConfig = axios.create({
	baseURL: process.env.REACT_APP_BASE_URL + '/api',
	headers: {
		Accept: "application/json",
		"Content-Type": "application/json",
	},
});

apiConfig.interceptors.request.use(
	(config) => {
		const token = localStorage.getItem("token");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

const GET = (url: any, params?: any) => {
	return apiConfig.get(url, params && { params });
};

const POST = (url: any, data: any) => {
	return apiConfig.post(url, data);
};

const PUT = (url: any, data: any) => {
	return apiConfig.put(url, data);
};

const DELETE = (url: any) => {
	return apiConfig.delete(url);
};

const PATCH = (url: any, data: any) => {
	return apiConfig.patch(url, data);
};

export const API = {
	GET,
	POST,
	PUT,
	DELETE,
	PATCH,
};
